export default [
  // Notifications router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Notifications",
      layout: "dashboard",
    },
    path: "/notifications",
    name: "notifications",
    component: () => import("@/layouts/index/NotificationIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Envoyer une notification",
          layout: "dashboard",
        },
        path: "send",
        name: "notifications-send",
        component: () => import("@/views/notifications/Send.vue"),
      },
    ],
  },
];
